export const ApiFindPatentFolders = Symbol.for('ApiFindPatentFolders');
